import styled from "styled-components";

export const ProductTypeTabsWrapper = styled.div`
  display: flex;
  gap: 5rem;
  margin: 8rem auto auto;
  max-width: 30vw;

  .product-type-tab {
    padding: 0.5rem 1rem;
    border-bottom: 2px solid #e0e2e6;
    background: #fff;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 500;
    color: #4a4f57;
    transition:
      border-color 0.15s,
      background 0.15s;

    &:hover {
      border-color: #c5c8ce;
    }

    &.active {
      border-color: #1a1a2e;
      color: #1a1a2e;
      font-weight: 600;
    }
  }
`;
